import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
})
export class NumberFormatPipe implements PipeTransform {
  transform(value :number | string, showDecimals :boolean = false) :string {
    const decimals :number = showDecimals ? 2 : 0;
    const decPoint :string = '.';
    const thousandsSep :string = ',';

    value = (value + '').replace(/[^0-9+\-Ee.]/g, '');
    const n :number = !isFinite(+value) ? 0 : +value;
    const prec :number = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep :string = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
    const dec :string = typeof decPoint === 'undefined' ? '.' : decPoint;

    const toFixedFix = (n :number, prec :number) :string => {
      const k :number = Math.pow(10, prec);

      return '' + Math.round(n * k) / k;
    };

    const s :string[] = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split(
      '.',
    );
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if (showDecimals && (s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    return showDecimals ? s.join(dec) : s[0];
  }
}
